import { Injectable } from "@angular/core";
import { EventEmitter } from "@angular/core";
import { Usuario } from './pages/login/usuario.model'


@Injectable()
export class DadosAcessoService{
    public cod_oper: number;
    public iniciais: string;
    public nome_fantasia: string
    public cod_loja: string
    public exibirBotaoEditar: any
    public exibirCadOper: any
    public id_not: any;

    emitirNovoAcesso = new EventEmitter<Usuario[]>();
    static criarNovoAcesso = new EventEmitter<Usuario[]>()


//Pega os dados de acesso do Operador e grava em variáveis para acesso da aplicação
    criarNovoAcesso(acesso: Usuario[]){
        this.emitirNovoAcesso.emit(acesso)        
        this.cod_oper = acesso[0].id_oper;
        this.iniciais = acesso[0].nome_pessoa;
        this.cod_loja = acesso[0].cod_loja
        this.nome_fantasia = acesso[0].fantasia_nome;
        this.exibirBotaoEditar = sessionStorage.getItem('ExibirBotaoEditar')
        this.exibirCadOper = sessionStorage.getItem('exibirCadOper')
    }

//Envia o Codigo de Operador
    recuperarCodOper(): number{
        return this.cod_oper;
    }

    recuperarExibirEditar(){
        return this.exibirBotaoEditar
    }

    recuperarCadOper(){
        return this.exibirCadOper
    }


//Envia os códigos da loja
    recuperarLoja(): string{
        return this.cod_loja
    }

    setIDNOT(id_noticia: any): any{
        this.id_not = id_noticia;
    }


    recuperarIDNOT(): any{
        return this.id_not;
    }


//verifica se o usuario deslogou
    recuperarDadosDeAcesso(): boolean{
        if(this.iniciais === undefined || this.nome_fantasia === undefined || this.iniciais === null || this.nome_fantasia === null || this.nome_fantasia === "" || this.iniciais === ""){
            return false
        }
        return true
    }
}


// WEBPACK FOOTER //
// ./src/app/dadosAcesso.service.ts